module.exports = __webpack_public_path__ + "static/media/credit_card_brands.45996ba6.png";